export default "__VITE_ASSET__fJr68cnx__"